export const parseJson = <T extends Object>(configuration?: string): T | undefined => {
  if (!configuration) return undefined;

  try {
    return JSON.parse(configuration);
  } catch {
    return undefined;
  }
};
